var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.currentRouteName,attrs:{"id":"app"}},[_c('Modal'),_c('HcpAdhdPopup'),_c('Cookie'),_c('irsh-header'),_c('router-view',{staticClass:"page"}),_c('div',[_c('div',[_c('irsh-widget')],1),_c('div',{staticClass:"isi-wrapper"},[_c('irsh-indication',{attrs:{"id":"indication"}})],1)]),_c('irsh-footer'),_c('IsiTuner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }